// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSaveOutlinedSvg from "@fishx/icons-svg/es/asn/PSaveOutlined";
import FishxIcon from '../components/FishxIcon';

var PSaveOutlined = function PSaveOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSaveOutlinedSvg
  }));
};

PSaveOutlined.displayName = 'PSaveOutlined';
export default React.forwardRef(PSaveOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSaveOutlined.js
// module id = 3611
// module chunks = 0